class Amount {
  static NORMAL = "normal";
  static LIGHT = "light";
  static EXTRA = "extra";

  constructor(type, label, cost) {
    this.id = type;
    this.cost = cost;
    this.label = label;
  }
}

export default Amount;


// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/classes/Amount.js